const signupForm = () => {
	$('.simform .js-form-item-email-address').addClass('current');

	let i = 1; $('.newsletter__signup-form').each(function() {
		$(this).attr('id', 'mailchimp-form-' + i);

		var mailchimpPopupSignupForm = document.getElementById( 'mailchimp-form-' + i );
		new stepsForm(mailchimpPopupSignupForm);

		i++;
	});

	$('.newsletter__signup-form').on('submit', function(e) {
		e.preventDefault();
		
		const form = $(this);

		form.addClass('submitting');
		$('.newsletter__signup-form.submitting .simform-inner').addClass('hide');
		$('.newsletter__signup-form.submitting .final-message').addClass('show');

		const emailAddress = form.find('input[name="email_address"]').val();
		const firstName = form.find('input[name="first_name"]').val();
		const lastName = form.find('input[name="last_name"]').val();

		$.ajax({
			type: 'POST',
			dataType: 'html',
			url: main__js_vars.ajaxurl,
			data: {
				'email_address' : emailAddress,
				'first_name' : firstName,
				'last_name' : lastName,
				'action': 'ajax_newsletter_signup'
			},
			success: function (data) {
				const returnedData = JSON.parse(data);
	
				$('.newsletter__signup-form.submitting .final-message').removeClass('show');
				$('.newsletter__signup-form.submitting .final-message').text(returnedData.response);
				$('.newsletter__signup-form.submitting .final-message').addClass('show');
				$('.newsletter__signup-form.submitting').removeClass('submitting');
			},
			error : function (jqXHR, textStatus, errorThrown) {
				$(this).html($.parseJSON(jqXHR.responseText) + ' :: ' + textStatus + ' :: ' + errorThrown);
				console.log(jqXHR);
			},
		});
	});
};